/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiBridgeAlert } from './ApiBridgeAlert';
import {
    ApiBridgeAlertFromJSON,
    ApiBridgeAlertFromJSONTyped,
    ApiBridgeAlertToJSON,
    ApiBridgeAlertToJSONTyped,
} from './ApiBridgeAlert';

/**
 * 
 * @export
 * @interface BridgeAlertsPage
 */
export interface BridgeAlertsPage {
    /**
     * 
     * @type {number}
     * @memberof BridgeAlertsPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof BridgeAlertsPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof BridgeAlertsPage
     */
    total: number;
    /**
     * 
     * @type {Array<ApiBridgeAlert>}
     * @memberof BridgeAlertsPage
     */
    content: Array<ApiBridgeAlert>;
}

/**
 * Check if a given object implements the BridgeAlertsPage interface.
 */
export function instanceOfBridgeAlertsPage(value: object): value is BridgeAlertsPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function BridgeAlertsPageFromJSON(json: any): BridgeAlertsPage {
    return BridgeAlertsPageFromJSONTyped(json, false);
}

export function BridgeAlertsPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): BridgeAlertsPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(ApiBridgeAlertFromJSON)),
    };
}

export function BridgeAlertsPageToJSON(json: any): BridgeAlertsPage {
    return BridgeAlertsPageToJSONTyped(json, false);
}

export function BridgeAlertsPageToJSONTyped(value?: BridgeAlertsPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(ApiBridgeAlertToJSON)),
    };
}

